import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/auth";
import {
  showCustomToast,
  CustomToastContainer,
} from "../../components/CustomToast";
import logo from "../../assets/logo.png";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import admin2 from "../../assets/admin2.gif";

const AdminLogin = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [auth, setAuth] = useAuth(); // Using authentication context
  const navigate = useNavigate();


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading

    try {
      const response = await fetch("https://api.makeeasydocuments.com/api/adminroutes/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      console.log("Admin Login Response:", data); // Debugging

      if (!response.ok || data.error) {
        showCustomToast(data.error || "Invalid credentials!", "error");
        return;
      }

      if (!data.token) {
        throw new Error("No token received!");
      }

      // Validate & decode token
      const tokenParts = data.token.split(".");
      if (tokenParts.length !== 3) {
        throw new Error("Invalid token format!");
      }

      const payload = JSON.parse(atob(tokenParts[1]));
      const adminId = payload._id;

      const adminWithId = {
        ...data.user,
        _id: adminId,
      };

      // // **Check if user is admin**
      // if (data.user.role == 1) {
        setAuth({
          user: adminWithId,
          token: data.token,
        });

        localStorage.setItem(
          "auth",
          JSON.stringify({ user: adminWithId, token: data.token })
        );
        localStorage.setItem("token", data.token);

        // Redirect to admin dashboard
        navigate("/admin");
        showCustomToast("Admin logged in successfully!", "success");
      // } else {
      //   showCustomToast("Access denied! Only admins can log in.", "error");
      // }
    } catch (err) {
      console.error("Admin login error:", err);
      showCustomToast("Something went wrong!", "error");
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  return (
    <div>
      <br />
      <br />
      <br />
      <div className="flex w-full max-w-sm mx-auto overflow-hidden bg-white !bg-white rounded-lg shadow-2xl lg:max-w-4xl">
        <div className="hidden bg-cover lg:block lg:w-1/2 pt-20">
          <img src={admin2} alt="login animation" className="w-50 h-50" />
        </div>
        <div className="w-full px-6 py-8 md:px-8 lg:w-1/2">
          <div className="flex justify-center mx-auto">
            <img
              className="h-20 w-30 mr-3"
              src={logo}
              alt="Make Easy Documents Logo"
            />
          </div>
          <p className="mt-3 text-xl text-center text-black">
  Welcome back!
</p>


          <form onSubmit={handleSubmit}>
            <div className="mt-4">
              <label
                className="block mb-2 text-sm font-medium text-black"
                htmlFor="email"
              >
                Email Address
              </label>
              <input
                id="email"
                name="email"
                className="block w-full px-4 py-2 text-black bg-white border rounded-lg !bg-white !text-black focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300"
                type="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
          
            <div className="mt-4">
              <div className="flex justify-between">
                <label
                  className="block mb-2 text-sm font-medium text-black"
                  htmlFor="password"
                >
                  Password
                </label>
                <Link
                  onClick={() => window.scrollTo(0, 0)}
                  to="/forgot_password"
                  className="text-xs text-black hover:underline"
                >
                  Forgot Password?
                </Link>
              </div>
              <div className="relative">
                <input
                  id="password"
                  name="password"
                  className="block w-full px-4 py-2 text-black bg-white border rounded-lg !bg-white !text-black focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300"
                  type={showPassword ? "text" : "password"}
                  value={formData.password}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  className="absolute right-2 top-2 text-black"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? (
                    <AiFillEyeInvisible size={20} />
                  ) : (
                    <AiFillEye size={20} />
                  )}
                </button>
              </div>
            </div>
          
            <div className="mt-6">
              <button
                type="submit"
                className="w-full px-6 py-3 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-gray-800 rounded-lg hover:bg-gray-700 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
              >
                Sign In
              </button>
            </div>
          </form>
          
        </div>
      </div>
      <br />
      <br />
      <br />
      <CustomToastContainer />
    </div>
  );
};

export default AdminLogin;
